import { EntityType } from "../fields/metadata";
import { ApiClient } from "./client"

export class EmailProvider {
    private static _apiClient = new ApiClient();

    static async getByExternalId(type: EmailType, id: string) {
        return await this._apiClient.get(`/email/by-external-id?type=${type}&id=${encodeURIComponent(id)}`) as EmailInfo
    }

    static async save(email: Email) {
        return await this._apiClient.post('/email', email) as number;
    }

    static async updateEntityLink(emailEntityLink: EmailEntityLink) {
        await this._apiClient.put('/email/link', emailEntityLink);
    }
}

export interface EmailIdentity {
    id?: number;
    type: EmailType;
}

export interface EmailEntityLink extends EmailIdentity {
    entityId?: number;
    entityType?: EntityType;
}

export interface EmailInfo extends EmailEntityLink {
    externalId?: string | null;
    timestamp: string;
    subject: string;
    personId: number;
}

export interface Email extends EmailInfo {
    body: string;

    from: EmailParty;
    to: EmailParty[];
    cc?: EmailParty[];
    bcc?: EmailParty[];

    attachments?: EmailAttachment[];

    userId: number;
}

export interface EmailParty {
    name: string;
    email: string;
}

export interface EmailAttachment {
    type: AttachmentType;
    name: string;
    data: string;
}

export enum EmailType {
    Outbound,
    Inbound,
}

export enum AttachmentType {
    WebcrmEmailAttachment,
    WebcrmDocumentAttachment,
    Base64EncodedAttachment,
    OutlookEmailAttachment,
    EmlCombinedAttachment,
}

export interface WebcrmEmailAttachmentData {
    id: number
}

export interface WebcrmDocumentAttachmentData {
    id: number
}

export interface OutlookEmailAttachmentData {
    attachmentId: string;
    accessToken: string;
}